import { experiment } from './experiment';

/**
 * Used for getting the users experiment variant
 * @param {string} experimentName - The experiment name we want to see the users variant for.
 */
export const useExperiment = (experimentName) => {
  const variant = experiment.variant(experimentName);

  return [experiment.isLoading, variant?.value, variant?.payload];
};
